import React, { useRef, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';

import { CircularProgress } from '@material-ui/core';
import { SubmitHandler, FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';

import history from '~/services/history';

import Input from '../../components/Form/Input';
import { useAuth } from '../../hooks/auth';
import getValidationErrors from '../utils/getValidationErrors';
import { Container } from './styles';

interface FormData {
  newPassword: string;
  confirmedNewPassword: string;
}

const ChangeForgotPassword: React.FC = (): JSX.Element => {
  const formRef = useRef<FormHandles>(null);

  const {
    loading,
    changeForgotPassword,
    forgotPasswordSuccess,
    resetForgotPasswordSuccess,
  } = useAuth();
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);

  const token = searchParams.get('token') || '';
  const [warning, setWarning] = useState(false);

  const handleSubmit: SubmitHandler<FormData> = async (data) => {
    try {
      formRef.current?.setErrors({});

      const schema = Yup.object().shape({
        newPassword: Yup.string()
          .matches(
            /^.*(?=.{8,})(?=.*\d)(?=.*[a-z])(?=.*[@$!%#?&])(?=.*[A-Z]).*$/,
            'A senha deve conter no mínimo 8 caracteres, uma letra maiúscula, uma letra minúscula, um número e um caractere especial',
          )
          .required('Obrigatório. Preencha uma nova senha.'),
        confirmedNewPassword: Yup.string().oneOf(
          [Yup.ref('newPassword'), null],
          'As senhas precisam ser iguais.',
        ),
      });

      await schema.validate(data, {
        abortEarly: false,
      });

      const { newPassword } = data;

      changeForgotPassword(newPassword, token);
    } catch (err) {
      if (err instanceof Yup.ValidationError) {
        const errors = getValidationErrors(err);

        formRef.current?.setErrors(errors);
      }
    }
  };

  const checkCapsLock = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.getModifierState('CapsLock') && e.key === 'CapsLock') {
      if (!warning) {
        setWarning(true);
      } else {
        setWarning(false);
      }
    }
  };

  useEffect(() => {
    if (forgotPasswordSuccess) {
      resetForgotPasswordSuccess();
      history.push('/');
      toast.success('Nova senha cadastrada!');
    }
  }, [forgotPasswordSuccess, resetForgotPasswordSuccess]);

  return (
    <Container>
      <Form ref={formRef} onSubmit={handleSubmit}>
        <h1>Esqueceu sua senha ?</h1>
        <p>Insira sua nova senha.</p>
        <Input
          name="newPassword"
          type="password"
          placeholder="Senha"
          label="Senha"
          autoFocus
          onKeyUp={(e) => checkCapsLock(e)}
        />
        <Input
          name="confirmedNewPassword"
          type="password"
          placeholder="Confirme sua senha"
          label="Confirme sua senha"
          onKeyUp={(e) => checkCapsLock(e)}
        />
        {warning && <span>Caps Lock ativado</span>}

        <button type="submit">
          {loading ? (
            <CircularProgress size={24} color="inherit" />
          ) : (
            'Definir como nova senha'
          )}
        </button>
      </Form>
    </Container>
  );
};

export default ChangeForgotPassword;
